import React from "react";
import "./PeriodSelector.scss";

const PeriodSelector = ({ period, setPeriod }) => {
  const periods = [
    { value: "m", label: "Monthly" },
    { value: "y", label: "Annual" },
  ];

  return (
    <div className="period-selector">
      <div className="selector-container">
        {periods.map((periodOption) => (
          <button
            key={periodOption.value}
            className={`period-button ${period === periodOption.value ? "active" : "inactive"}`}
            onClick={() => setPeriod(periodOption.value)}
          >
            {periodOption.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default PeriodSelector;
